import Img from '../../images/service-01.png'
import Img2 from '../../images/service-02.png'
import Img3 from '../../images/service-03.png'
import Img4 from '../../images/service-04.png'
import Img5 from '../../images/service-05.png'

const Main = () => {
    return (
        <section className="hero-section-s3" style={{background:"#F6F7FA", padding: window.innerWidth >= 768 ? "1000px 0px" : "1000px 0px"}}>
          <div className="container">
            <div style={{
              background:"white",
              display: "flex",
              flexDirection: window.innerWidth >= 768 ? "row" : "column",
              justifyContent: "space-between"
              }}>
              <div style={{padding: window.innerWidth >= 768 ? "40px" : "20px", height: window.innerWidth >= 768 ? "" : "auto", width: window.innerWidth >= 768 ? "600px" : "100%"}}>
                <div style={{fontSize: window.innerWidth >= 768 ? "32px" : "20px", color:"#313337", fontWeight:"600", marginBottom: window.innerWidth >= 768 ? "30px" : "20px"}}>폐수 재이용사업</div>
                <div style={{fontSize: window.innerWidth >= 768 ? "20px" : "14px", color:"#41444A", fontWeight:"400", lineHeight: "1.6"}}>
                  각종 수탁된 산업용 폐수를 이용하여 제품의 원료 또는 <br />
                  재료로 재생, 이용하는 사업을 수행하고 있으며, <br />
                  폐수의 금속 추출에 있어서 당사만의 특화 기술력이 <br />
                  타사에 비하여 가격경쟁력과 수율이 우수합니다.
                </div>
              </div>
              <div><img src={Img} alt="" style={ window.innerWidth >= 768 ? {width:"851px", height:"332px"} :  {width:"100%", height:"150px"}} /></div>
            </div>
            <div style={{
              background:"white",
              display: "flex",
              flexDirection: window.innerWidth >= 768 ? "row" : "column",
              justifyContent: window.innerWidth >= 768 ? "" : "space-between",
              marginTop:"40px"
              }}>
              <div style={{order: window.innerWidth >= 768 ? 0 : 2}}><img src={Img2} alt="" style={ window.innerWidth >= 768 ? {width:"851px", height:"332px"} :  {width:"100%", height:"150px"}} /></div>
              <div style={{padding: window.innerWidth >= 768 ? "40px" : "20px", height: window.innerWidth >= 768 ? "" : "auto", order: window.innerWidth >= 768 ? 0 : 1, textAlign:"start", width: window.innerWidth >= 768 ? "600px" : "100%"}}>
                <div style={{fontSize: window.innerWidth >= 768 ? "32px" : "20px", color:"#313337", fontWeight:"600", marginBottom: window.innerWidth >= 768 ? "30px" : "20px"}}>금속원료 재생사업</div>
                <div style={{fontSize: window.innerWidth >= 768 ? "20px" : "14px", color:"#41444A", fontWeight:"400", lineHeight: "1.6"}}>
                  폐기물, 스크랩, 기타 폐품 등을 처리하여 재생용의 <br />
                  금속원료 물질로 전환하여 재활용하는 사업으로, <br />
                  연속적으로 투입되는 재활용이 가능한 폐기물로부터 <br />
                  금속원료 물질을 분리 및 분류하여 회수하는 산업활동을 { (window.innerWidth > 400 ) && <br /> }
                  포함하여 수행하고 있습니다.
                </div>
              </div>
            </div>
            <div style={{
              background:"white",
              display: "flex",
              flexDirection: window.innerWidth >= 768 ? "row" : "column",
              justifyContent: "space-between",
              marginTop:"40px"
              }}>
              <div style={{padding: window.innerWidth >= 768 ? "40px" : "20px", height: window.innerWidth >= 768 ? "" : "auto", textAlign:"start", width: window.innerWidth >= 768 ? "600px" : "100%"}}>
                <div style={{fontSize: window.innerWidth >= 768 ? "32px" : "20px", color:"#313337", fontWeight:"600", marginBottom: window.innerWidth >= 768 ? "30px" : "20px"}}>지정폐기물 종합 재활용 사업</div>
                <div style={{fontSize: window.innerWidth >= 768 ? "20px" : "14px", color:"#41444A", fontWeight:"400", lineHeight: "1.6"}}>
                  법정되어 있는 지정폐기물을 처리 지정사업자 인허가를 { (window.innerWidth > 400 ) && <br /> }
                  득하여, 지정폐기물 속에 포함된 각종 유용 물질을 <br />
                  추출하여 재활용하는 사업을 진행하고 있으며, <br />
                  유해물질의 고도처리와 함께 <br />
                  환경자원을 보존하는 일에 앞장서고 있습니다.
                </div>
              </div>
              <div><img src={Img3} alt="" style={ window.innerWidth >= 768 ? {width:"851px", height:"332px"} :  {width:"100%", height:"150px"}} /></div>
            </div>
            <div style={{
              background:"white",
              display: "flex",
              flexDirection: window.innerWidth >= 768 ? "row" : "column",
              justifyContent: window.innerWidth >= 768 ? "" : "space-between",
              marginTop:"40px"
              }}>
              <div style={{order: window.innerWidth >= 768 ? 0 : 2}}><img src={Img4} alt="" style={ window.innerWidth >= 768 ? {width:"851px", height:"332px"} :  {width:"100%", height:"150px"}} /></div>
              <div style={{padding: window.innerWidth >= 768 ? "40px" : "20px", height: window.innerWidth >= 768 ? "" : "auto", order: window.innerWidth >= 768 ? 0 : 1, textAlign:"start", width: window.innerWidth >= 768 ? "600px" : "100%"}}>
                <div style={{fontSize: window.innerWidth >= 768 ? "32px" : "20px", color:"#313337", fontWeight:"600", marginBottom: window.innerWidth >= 768 ? "30px" : "20px"}}>폐수 처리 시스템</div>
                <div style={{fontSize: window.innerWidth >= 768 ? "20px" : "14px", color:"#41444A", fontWeight:"400", lineHeight: "1.6"}}>
                  각종 산업폐수을 수탁받아 고도처리(고체액체분리·물리 { (window.innerWidth > 400 ) && <br /> }
                  화학적 처리·생물화학적 처리·열처리 방법)에 의해 <br />
                  폐수를 정화·배수하는 사업을 수행하고 있으며, <br />
                  특히 당사는 고도처리가 어려운 저농도 폐수처리에 <br />
                  우수한 역량을 보유하고 있습니다.
                </div>
              </div>
            </div>
            <div style={{
              background:"white",
              display: "flex",
              flexDirection: window.innerWidth >= 768 ? "row" : "column",
              justifyContent: "space-between",
              marginTop:"40px"
              }}>
              <div style={{padding: window.innerWidth >= 768 ? "40px" : "20px", height: window.innerWidth >= 768 ? "" : "auto", textAlign:"start", width: window.innerWidth >= 768 ? "600px" : "100%"}}>
                <div style={{fontSize: window.innerWidth >= 768 ? "32px" : "20px", color:"#313337", fontWeight:"600", marginBottom: window.innerWidth >= 768 ? "30px" : "20px"}}>연구소</div>
                <div style={{fontSize: window.innerWidth >= 768 ? "20px" : "14px", color:"#41444A", fontWeight:"400", lineHeight: "1.6"}}>
                  본 연구소는 체계적인 분석 역량과 차별화된 기술력을 <br />
                  기반으로 다양한 산업 분야에서 정밀 분석 서비스를 <br />
                  제공하고 있습니다. <br />
                  최신 장비 도입과 표준화된 절차 구축으로 신뢰도 높은  <br />
                  데이터를 생산하며, 지속적인 연구와 인력 양성을 통해  <br />
                  정확하고 재현성 높은 결과를 제공합니다.
                </div>
              </div>
              <div><img src={Img5} alt="" style={ window.innerWidth >= 768 ? {width:"851px", height:"350px"} :  {width:"100%", height:"150px"}} /></div>
            </div>
          </div>
        </section>
    )
};
export default Main;